import React, {useState} from 'react';
import styled from "styled-components";
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {ValidatorForm} from 'react-material-ui-form-validator';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Text from "../Text";
import Tx from "../Tx";
import {colors} from "../../maps/colors";
import {api} from "../../maps/data.js";

const WrapperStyled = styled.div`
    text-align: center;
`;

const ModelInfoStyled = styled.div`
    text-align: left;
    display: grid;
    grid-template-columns: 230px 230px auto;

    .label {
        font-size: 13px;
        color: ${colors.TEAL};
        margin-right: 5px;
    }
`;

const FormStyled = styled.div`
    display: grid;
    grid-template-columns: 200px 200px 220px;
    grid-gap: 20px;
`;

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const UploadFirmware = ({sensorModels, forceGetList}) => {
    const [sensorModelType, s_sensorModelType] = useState("");
    const [version, s_version] = useState("0.0.1");
    const [fileUpload, s_fileUpload] = useState("");

    const save = () => {
        api({
            type: "uploadFirmware",
            data: {
                fileName: fileUpload.fileName,
                fileContent: fileUpload.fileContent,
                modelTypeId: sensorModelType,
                version
            }
        }).then(data => {
            s_sensorModelType("");
            s_version("");
            s_fileUpload("");
            forceGetList();
        }).catch(e => {
            console.error(e);
        });
    };

    const fileHandle = (event) => {
        const fileObj = event.target.files[0];
        if(fileObj){
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = e => {
                const jsonData = {
                    fileName: fileObj.name,
                    fileContent: reader.result
                };
                s_fileUpload(jsonData);
            }
        }
    };

    const selectedModel = sensorModels?.find(pp => pp._id === sensorModelType);

    return (
        <WrapperStyled>
            <ValidatorForm
                onSubmit={save}
                onError={errors => console.log(errors)}>
                <FormStyled>
                    <FormControl fullWidth style={{marginBottom: 10}}>
                        <InputLabel id="demo-simple-select-label"><Tx>firmware.select_sensor_model</Tx></InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={sensorModelType}
                            label="Select Sensor Model"
                            onChange={e => {
                                s_sensorModelType(e.target.value);
                            }}>
                            {sensorModels.map(ss => {
                                return (
                                    <MenuItem key={ss._id} value={ss._id}>{ss.name}</MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                    <Text
                        label="firmware.version"
                        value={version}
                        onChange={(text) => {
                            s_version(text);
                        }}
                        validators={['required']}
                        errorMessages={['this field is required']}/>
                    <Button style={{height: 55}} component="label" variant="contained" startIcon={<CloudUploadIcon/>}>
                        <Tx>firmware.upload_file</Tx>
                        <VisuallyHiddenInput type="file" onChange={fileHandle}/>
                    </Button>
                </FormStyled>
                {selectedModel && (
                    <ModelInfoStyled>
                        <div className="common-info">
                            <div className="item-dkp">
                                <span className="label">Name:</span>
                                <span className="val">{selectedModel.name}</span>
                            </div>
                            <div className="item-dkp">
                                <span className="label">Total versions:</span>
                                <span className="val">{selectedModel.firmwareCount}</span>
                            </div>
                        </div>

                        <div className="version-info">
                            <div className="item-dkp">
                                <span className="label">Last version:</span>
                                <span className="val">{selectedModel?.lastFirmware?.version || "None"}</span>
                            </div>
                        </div>
                        {fileUpload && (
                            <div className="file-info">
                                <div className="item-dkp">
                                    <span className="label">Upload file:</span>
                                    <span className="val">{fileUpload.fileName}</span>
                                </div>
                            </div>
                        )}
                    </ModelInfoStyled>
                )}

                <Button
                    disabled={!version || !selectedModel || !fileUpload}
                    autoFocus type="submit">
                    <Tx>g.save</Tx>
                </Button>
            </ValidatorForm>
        </WrapperStyled>
    );
};

export default UploadFirmware;